import { render, staticRenderFns } from "./ExportFilesForm.vue?vue&type=template&id=52ba3a8e&"
import script from "./ExportFilesForm.vue?vue&type=script&lang=js&"
export * from "./ExportFilesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports